import { areDateStringsEqual, compareDateStrings } from 'shared/utils/validate-date';

export const isOvernightTimeRange = (startTime: string, endTime: string): boolean =>
  compareDateStrings(endTime, startTime) || areDateStringsEqual(endTime, startTime);
